import { ClockCounterClockwiseIcon as PhosphorClockCounterClockwiseIcon } from "@phosphor-icons/react/dist/ssr/ClockCounterClockwise";

import { createAppIcon } from "@/components/createAppIcon";

export const HistoryIcon = /* @__PURE__ */ createAppIcon(PhosphorClockCounterClockwiseIcon);
